import { Instance } from 'mobx-state-tree'
import { LearningModuleStatModelBase } from './LearningModuleStatModel.base'

/* The TypeScript type of an instance of LearningModuleStatModel */
export interface LearningModuleStatModelType extends Instance<typeof LearningModuleStatModel.Type> {}

/* A graphql query fragment builders for LearningModuleStatModel */
export {
  selectFromLearningModuleStat,
  learningModuleStatModelPrimitives,
  LearningModuleStatModelSelector
} from './LearningModuleStatModel.base'

/**
 * LearningModuleStatModel
 */
export const LearningModuleStatModel = LearningModuleStatModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
